export const General = 0;
export const Employee = 1;
export const Supervisor = 2;